import { StockEditComponent } from './stock-edit/stock-edit.component';
import { StockEditModalComponent } from './stock-edit/stock-edit-modal.component';
import { StockListComponent } from './stock-list/stock-list.component';
import { StockListModalComponent } from './stock-list/stock-list-modal.component';

export const components: any[] = [
  StockEditComponent,
  StockEditModalComponent,
  StockListComponent,
  StockListModalComponent
];

export * from './stock-edit/stock-edit.component';
export * from './stock-edit/stock-edit-modal.component';
export * from './stock-list/stock-list.component';
export * from './stock-list/stock-list-modal.component';
